var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { id: "admin-banner-table-wrapper" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "btn-primary mt-5 mb-3",
          on: { click: _vm.createClick }
        },
        [_vm._v("Nový banner")]
      ),
      _c("banner-dialog", {
        ref: "bannerActionDialog",
        attrs: { action: _vm.actionDialogType, entityId: _vm.editId },
        on: { successEvent: _vm.loadData }
      }),
      _c("v-data-table", {
        attrs: {
          "disable-pagination": false,
          headers: _vm.headers,
          items: _vm.items,
          "hide-default-footer": "",
          page: _vm.page,
          "items-per-page": 10,
          "single-select": false,
          "single-expand": false,
          "item-key": "pkid",
          loading: _vm.loading,
          loadingText: "Načítavam dáta ..."
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "page-count": function($event) {
            _vm.pageCount = $event
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.stav",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("v-switch", {
                    on: {
                      change: function($event) {
                        return _vm.updateStatus(item.pkid, item.stav)
                      }
                    },
                    model: {
                      value: item.stav,
                      callback: function($$v) {
                        _vm.$set(item, "stav", $$v)
                      },
                      expression: "item.stav"
                    }
                  })
                ]
              }
            },
            {
              key: "item.datum_do",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.datum_do
                    ? _c("span", [_vm._v(_vm._s(item.datum_do.formatDate()))])
                    : _vm._e()
                ]
              }
            },
            {
              key: "item.akcie",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "content-class": "admin-banner-table-menu",
                        "offset-x": "",
                        transition: "slide-x-transition",
                        left: "",
                        "open-on-hover": "",
                        "nudge-left": "5"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      { attrs: { dark: "", icon: "" } },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-dots-vertical")])],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "v-list",
                        {
                          attrs: {
                            id: "admin-banner-table-menu-list",
                            elevation: "1"
                          }
                        },
                        _vm._l(_vm.menu, function(m, i) {
                          return _c(
                            "v-list-item",
                            {
                              key: i,
                              class: m.color,
                              attrs: { link: "", dense: "" },
                              on: {
                                click: function($event) {
                                  return _vm.actionClick(m.nazov, item.pkid)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                { staticClass: "mr-4" },
                                [
                                  _c("v-icon", {
                                    domProps: { textContent: _vm._s(m.icon) }
                                  })
                                ],
                                1
                              ),
                              _c("v-list-item-title", [_vm._v(_vm._s(m.nazov))])
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }